import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import store from '../store'

Vue.use(VueRouter)
// const staff = (location.href.indexOf('localhost') > -1 ) ? true : false ; 
// console.log( "staff:: "  , store.state.staff , store.state.user  )  ;


const loggedinGaurd = () => (to, from, next) => {
  // console.log(store.state)
  // return next('/maintenance')
  // console.log( "loggedinGaurd :: " ,  to, from, next) ; 
  // console.log('-------------------------------')

  if (store.state.acessToken && store.state.user) {
    return next()
  }
  if (!store.state.user.auth_sms || store.state.user.auth_sms == 'N') {
    const pass = VueCookies.get('asp')

    if (pass) return next()
    return next('/phone/verify')
  }
  store.dispatch('LOGOUT')
  store.commit('loading', false)
  return next('/signin') ; 
  // if( store.state.staff == true ) {
  //   return next('/staffindex')
  // }else{
  //   return next('/signin')
  // }
  
}

const refCodeJoin = () => (to, from , next  ) => {
  // refer save to join page 
  console.log( 'refCodeJoin refer_code::' , to.params.refer_code  ) ;   
  
  if(to.params && to.params.refer_code  ) {

      let expiredays = 1 
      let today = new Date()
      today = new Date(
        parseInt(today.getTime() / 86400) * 86400 + 54000000
      )
      if (today > new Date()) {
        expiredays = expiredays - 1
      }
      today.setDate(today.getDate() + expiredays)      
      VueCookies.set('recommend', to.params.refer_code , today.toGMTString())
      
  }

  return next('/signin')

}

const notLoggedinGaurd = () => (to, from, next) => {
  // return next('/maintenance')
//  console.log( "notLoggedinGaurd :: " ,  to, from, next) ; 
// console.log( 'sssssss:: ' , store.state.wlable)
 
  if (store.state.acessToken) return next('/home')
  return next()
}
const phoneVerifyGaurd = () => (to, from, next) => {
  // console.log(store.state)
  // return next('/maintenance')

  if (store.state.acessToken && store.state.user) {
    return next()
  }
  store.dispatch('LOGOUT')
  store.commit('loading', false)
  if( store.state.staff == true ) {
    // return next('/staffindex')
    return next('/signin')
  }else{
    return next('/signin')
  }
    
  // return next('/signin')
}
const routes = [
  {
    path: '/home',
    name: 'home',
    meta: {
    layout: 'App',
      // layout: store.state.staff? 'Staff': 'App',
    },
    component: () => import('@/views/Home'),
    beforeEnter: loggedinGaurd(),
  },
  // this.$cookies.set('asp', escape(true), today.toGMTString())
  // this.$router.push('/home')
  {
    path: '/refer/:refer_code',
    name: 'refer',
    meta: {
      layout: 'App',
    },
    // component: () => import('@/views/_Send'),
    beforeEnter: refCodeJoin(),
  },

  {
    path: '/send',
    name: 'send',
    meta: {
      layout: 'App',
    },
    component: () => import('@/views/_Send'),
    beforeEnter: loggedinGaurd(),
  },
  {
    path: '/buy',
    name: 'buy',
    meta: {
      layout: 'App',
    },
    // component: Pay,
    component: () => import('@/views/Buy'),
    beforeEnter: loggedinGaurd(),
  },

  {
    path: '/pay',
    name: 'pay',
    meta: {
      layout: 'App',
    },
    // component: Pay,
    component: () => import('@/views/Pay'),
    beforeEnter: loggedinGaurd(),
  },
  {
    path: '/staking',
    name: 'staking',
    meta: {
      layout: 'App',
    },
    component: () => import('@/views/Staking'),
    // component: PlanToUpdate,
    beforeEnter: loggedinGaurd(),
  },
  {
    path: '/',
    name: 'main',
    //redirect: (store.state.staff) ? '/staffindex' : '/signin',
    redirect:  '/signin',
    beforeEnter: loggedinGaurd(),
  },
  {
    path: '/staffindex',
    name: 'staffindex',
    meta: {
      // layout: 'Auth',
    },
    // component: () => import( (store.state.staff)  ? '@/views/LoginStaff' : '@/views/Login'),
    component: () =>  import('@/views/StaffIndex' ) ,
    beforeEnter: notLoggedinGaurd(),
  },    
  {
    path: '/staffjoin',
    name: 'staffjoin',
    meta: {
      // layout: 'Auth',
    },
    // component: () => import( (store.state.staff)  ? '@/views/LoginStaff' : '@/views/Login'),
    component: () => import('@/views/StaffJoin' ) ,
    // beforeEnter: notLoggedinGaurd(),
  }, 
  {
    path: '/staff',
    name: 'staff-main',
    meta: {
      // layout: 'App',
      layout: 'Staff',

    },
    // component: () => (location.href.indexOf('pay2.lassa') > -1 ) ?import('@/views/staff/Member') : import('@/views/staff/Pay'),
    component: () => import('@/views/staff/PayNone' ),

    beforeEnter: (to, from, next) =>{
      // console.log(  store.state.user       )
      // if( store.state.user.id  ) {
      //   if( store.state.user.grade > 0  ) {
      //     // 직원일 경우  
      //     return next()
      //   }else{
      //     // 직원  멤버가 아닐경우 
      //     return next("/home")
      //   }  
      // }else{
      //     // 로그인 필요 
      //     return next('/signin') ; 
      // }   
      return next()

    } 
  },
  {
    path: '/cards1',
    name: 'card-my1',
    meta: {
      // layout: 'Staff',
      layout: 'App',

    },
    component: () => import('@/views/cards/main_copy'),
  },

  {
    path: '/cards',
    name: 'card-my',
    meta: {
      // layout: 'Staff',
      layout: 'App',

    },
    component: () => import('@/views/cards/main'),
  },
  {
    path: '/nft1',
    name: 'nft-my1',
    meta: {
      // layout: 'Staff',
      layout: 'App',
    },
    component: () => import('@/views/Nft_details'),
  },  

  {
    path: '/nft',
    name: 'nft-my',
    meta: {
      // layout: 'Staff',
      layout: 'App',

    },
    component: () => import('@/views/NftMy'),
  },  
  {
    path: '/staff/member',
    name: 'staff-pay',
    meta: {
      // layout: 'Staff',
      layout: 'App',

    },
    component: () => import('@/views/staff/Member'),
  }, 


  {
    path: '/signin',
    name: 'login',
    meta: {
      layout: 'Auth',
    },
    // component: () => import( (store.state.staff)  ? '@/views/LoginStaff' : '@/views/Login'),
    component: () => import('@/views/Login') ,
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/signin2',
    name: 'login2',
    meta: {
      layout: 'Auth',
    },
    // component: () => import( (store.state.staff)  ? '@/views/LoginStaff' : '@/views/Login'),
    component: () =>   import('@/views/Login') ,
    beforeEnter: notLoggedinGaurd(),
  },



  {
    path: '/market',
    name: 'market',
    meta: {
      //layout: 'Auth',
      layout: 'Market',
    },    
    component: () =>   import('@/views/Market' )  ,
    // beforeEnter: notLoggedinGaurd(),
  },


  {
    path: '/signup',
    name: 'signup',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/_Signup'),
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/signup/:code',
    name: 'signupCode',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/_Signup'),
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/event',
    name: 'event',
    meta: {
      layout: 'App',
    },
    // component: Pay,
    component: () => import('@/views/Event'),
    beforeEnter: loggedinGaurd(),
  },
  {
    path: '/config',
    // name: 'config',
    meta: {
      layout: 'App',
    },
    component: () => import('@/views/config/Config'),
    beforeEnter: loggedinGaurd(),
    children: [
      
      {
        path: '',
        name: 'config',
        meta: {
          layout: 'App',
        },
        component: () => import('@/views/config/ConfigHome'),
      }, 
      
      {
        path: 'test',
        name: 'test',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/Test'),
        beforeEnter: loggedinGaurd(),
        props: true
      },      
      // config/cards
      {
        path: 'cards',
        name: 'cards-tradelists',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/cardsTradeList'),
        beforeEnter: loggedinGaurd(),
        props: true
      }, 
      {
        path: 'news/lists',
        name: 'news',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/NewsList'),
        beforeEnter: loggedinGaurd(),
        props: true
      },      
      {
        path: 'news/:id',
        name: 'news',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/NewsView'),
        beforeEnter: loggedinGaurd(),
        props: true
      },
      {
        path: 'nft',
        name: 'nft',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/NftReg')
      },
      {
        path: 'history/eth',
        name: 'history-eth',
        meta: {
          layout: 'App',
        },
        component: () => import('@/views/config/TxHistory'),
      },
      {
        path: 'swap',
        name: 'swap',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/Swap')
      },
      {
        path: 'swap/success',
        name: 'swap-success',
        meta: {
          layout: 'App'
        },
        component: () => import('@/views/config/SwapSuccess')
      },
      {
        path: 'recommend',
        name: 'recommend',
        meta: {
          layout: 'App',
        },
        component: () => import('@/views/config/Recommend'),
      },
      {
        path: 'history/point',
        name: 'point',
        meta: {
          layout: 'App',
        },
        component: () => import('@/views/config/PointHistory'),
      },
      {
        path: 'point/out',
        name: 'out',
        meta: {
          layout: 'App',
        },
        component: () => import('@/views/config/Out'),
      },
    ],
  },
  {
    path: '/verify',
    name: 'verify',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/Verify'),
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/success',
    name: 'success',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/SuccessSignup'),
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/password',
    name: 'password',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/Password'),
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/password/verify',
    name: 'passwordVerify',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/PasswordVerify'),
    beforeEnter: notLoggedinGaurd(),
  },
  {
    path: '/phone/verify',
    name: 'phoneVerify',
    meta: {
      layout: 'Auth',
    },
    component: () => import('@/views/PhoneVerify'),
    beforeEnter: phoneVerifyGaurd(),
  },
  {
    path: '/maintenance',
    name: 'maintenance',

    component: () => import('@/views/Maintenance'),
  },
  {
    path: '*',
    component: () => import('@/components/NotFound'),
    beforeEnter: phoneVerifyGaurd(),
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router
